import { defineMessages } from 'react-intl';

export const messages: {
	allOptionVisualLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allOptionAccessibleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	accessibleMoreMenuLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	allOptionVisualLabel: {
		id: 'search-page.tab-filter.all-filter-visual-label',
		defaultMessage: 'All',
		description: 'Visual label for tab filters "All" option',
	},
	allOptionAccessibleLabel: {
		id: 'search-page.tab-filter.all-filter-accessible-label',
		defaultMessage: 'Filter by all apps',
		description: 'Accessible label for tab filters "All" option',
	},
	more: {
		id: 'search-page.tab-filter.more-dropdown-label',
		defaultMessage: 'More',
		description: 'Visual label for tab filters dropdown menu',
	},
	accessibleMoreMenuLabel: {
		id: 'search-page.tab-filter.accessible-more-dropdown-label',
		defaultMessage: 'Filter by more apps',
		description:
			'Non-visual label for tab filters dropdown menu. Needed because `More` is not enough context for users of screen readers.',
	},
});
